
//firefox用。
//isoのfirefoxのモバイルは、スクロール時にブラウザのURL入力欄が表示非表示になるが、その時に画面サイズが変わると判定されてしまう。
//その度に、iframeをリセットしてkiwi側にメッセージ送信するのは見た目に問題があるので、スクロール中かを判定し、余計なメッセージを送信しない。
export default class{
    private scrollingFlg = false;
    private clearId = -1;
    private funcAfterScroll:Function|null = null;
    public isScrolling():boolean{
        return this.scrollingFlg;
    }

    public nowScrolling():void{
        this.scrollingFlg = true;
        if(this.clearId !== -1){
            clearTimeout(this.clearId);
            this.clearId = -1;
        }
        this.clearId = setTimeout(()=> {
            this.scrollingFlg = false;
            this.clearId = -1;
            if(this.funcAfterScroll) {
                this.funcAfterScroll();
                this.funcAfterScroll = null;
            }    
        }, 100);    
    }

    public setCallBackOnScrollEnd(f:Function):void{
        this.funcAfterScroll = f;
    }
}
